module.exports = __webpack_public_path__ + "static/1-429acc5555a3cce75b9026558b39f30b.jpg";